var _desc, _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirdHouseGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 680,
    height: 800,
    viewBox: "0 0 680 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 340 400)",
    id: "6650b78b-dea8-4415-b562-1d4190d0fdd5"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -340,
    y: -400,
    rx: 0,
    ry: 0,
    width: 680,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "b4f4d72c-70fe-4d1d-9e89-254ad60a6bd0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23 0 0 3.23 336.22 197.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(183,121,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-125, -59)",
    d: "M 25 118 L 25 100 L 125 0 L 225 100 L 225 118 L 125 18 L 25 118 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23 0 0 3.23 336.73 425.79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(3,95,15)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-125, -133.5)",
    d: "M 204 101 L 204 245 L 46 245 L 46 101 L 125 22 L 204 101 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.95 0 0 4.26 348.83 708.92)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(0,0,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 3.955,
    ry: 3.671
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.25 0 0 13.2 339.05 374.84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 3.955,
    ry: 3.671
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdHouseGreen);
export default __webpack_public_path__ + "static/media/bird-house-green.1aa2d10412b557acf75ae99767bba7fb.svg";
export { ForwardRef as ReactComponent };